module.exports = __webpack_public_path__ + "static/media/student-end-season-top.05465c03.png";